/**
   *  Là chỉ tiêu
   */
export default {
  Empty: 0,
  IsInWhich: 1
};